import { routeFrontOfficeCommonUser } from '@/lib/routes/front/common/routeFrontOfficeCommonUser'
import { routeFrontOfficeGroupNews } from '@/lib/routes/front/common/routeFrontOfficeGroupNews'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'

export const getFrontOfficeGroupPharmacienAndUserTeam = [
  ...routeFrontOfficeCommonUser,
  ...routeFrontOfficeGroupNews,
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDIGROUP],
  roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_GROUP_USER_TEAM],
}))
